<template>
  <ui-max-width width="md" align="center" class="rm-child-margin">
    <span v-if="showGeneralProfileNote" style="margin-bottom: 10px">{{
      $t('candidate-profile-educational-general-profile-note', 'fr')
    }}</span>

    <general
      v-if="showCommonCards"
      :user="user"
      :margin="margin"
      forcedLanguage="fr"
      :personalDescription="personalDescription"
    />

    <about-you :profile="profile" :margin="margin" />

    <education :profile="profile" :margin="margin" />

    <immigration
      v-if="showCommonCards && !isFromCanada"
      :profile="profile"
      :hasImmigrationProject="hasImmigrationProject"
      :margin="margin"
      forcedLanguage="fr"
      :hasNationalities="hasNationalities"
    />

    <finances :profile="profile" :margin="margin" />

    <job :profile="profile" :margin="margin" />

    <languages v-if="showCommonCards && languages.length > 0" :languages="languages" :margin="margin" />
  </ui-max-width>
</template>

<script>
import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'
import { LangLevelList } from '@/mixins/lang-level-list'
import NavCandidateProfile from '@/components/nav/nav-candidate-profile'

import General from '@/components/candidate/profile-card/general'
import AboutYou from '@/components/candidate/profile-card/educational/about-you'
import Education from '@/components/candidate/profile-card/educational/education'
import Immigration from '@/components/candidate/profile-card/immigration'
import Finances from '@/components/candidate/profile-card/educational/finances'
import Job from '@/components/candidate/profile-card/educational/job'
import Languages from '@/components/candidate/profile-card/pro/languages'

export default {
  mixins: [LangLevelList],
  props: {
    user: {
      type: Object,
      required: true
    },
    showCommonCards: {
      type: Boolean,
      required: false,
      default: true
    },
    showGeneralProfileNote: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    NavCandidateProfile,
    General,
    AboutYou,
    Education,
    Immigration,
    Finances,
    Job,
    Languages
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    margin() {
      return this.mobile ? 'mb-3' : 'mb-4'
    },
    profile: function() {
      return this.user.profile
    },
    isFromCanada: function() {
      return this.user.profile.country && this.user.profile.country.countryCode === Consts.CANADA_COUNTRY_CODE
    },
    hasImmigrationProject: function() {
      return (
        this.profile.translationOrDefault !== null &&
        this.profile.translationOrDefault.immigrationProject !== null &&
        this.profile.translationOrDefault.immigrationProject !== undefined &&
        this.profile.translationOrDefault.immigrationProject !== ''
      )
    },
    hasNationalities: function() {
      return this.profile.nationalities !== null && this.profile.nationalities.length > 0
    },
    languages: function() {
      let languages = []

      if (this.profile.languages === undefined) {
        return languages
      }

      if (this.profile.languages.filter(x => x.language === Consts.LANGUAGE_FRENCH).length !== 0) {
        languages.push({
          label: i18n.instance().t('candidate-french-level-label'),
          options: this.langLabels(Consts.USER_TYPE_CANDIDATE),
          selected: this.getLangIndexById(
            this.profile.languages.filter(x => x.language === Consts.LANGUAGE_FRENCH)[0].level,
            Consts.USER_TYPE_CANDIDATE
          )
        })
      }

      if (this.profile.languages.filter(x => x.language === Consts.LANGUAGE_ENGLISH).length !== 0) {
        languages.push({
          label: i18n.instance().t('candidate-english-level-label'),
          options: this.langLabels(Consts.USER_TYPE_CANDIDATE),
          selected: this.getLangIndexById(
            this.profile.languages.filter(x => x.language === Consts.LANGUAGE_ENGLISH)[0].level,
            Consts.USER_TYPE_CANDIDATE
          )
        })
      }

      return languages
    },
    personalDescription: function() {
      if (this.user.profile.translationOrDefault !== null) {
        if (
          this.user.profile.translationOrDefault.personalDescriptionStudent !== null &&
          this.user.profile.translationOrDefault.personalDescriptionStudent !== ''
        ) {
          return this.user.profile.translationOrDefault.personalDescriptionStudent
        }
      }
      return ''
    }
  }
}
</script>
